module.exports = __webpack_public_path__ + "static/img/so2_4.4832ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so2_4.jpg
// module id = nu7F
// module chunks = 11